import {LeadEventTypeEnum} from "./event/LeadEvent";

export default class LeadAction {

	/**
	 * Convert string to LeadAction.
	 * @param {string} string
	 * @return {LeadAction}
	 */
	public static fromString(string: string): LeadAction {
		return new LeadAction(string)
	}

	/**
	 * Get label
	 * @return {string}
	 */
	public getActionLabel() {
		switch (this.id) {
			case LeadEventTypeEnum.Created:
				return LeadActionLabelEnum.Created;
			case LeadEventTypeEnum.Updated:
				return LeadActionLabelEnum.Updated;
			case LeadEventTypeEnum.StatusChanged:
				return LeadActionLabelEnum.StatusChanged;
			case LeadEventTypeEnum.NoteCreated:
				return LeadActionLabelEnum.NoteCreated;
			case LeadEventTypeEnum.QuoteCommentCreated:
				return LeadActionLabelEnum.QuoteCommentCreated;
			case LeadEventTypeEnum.QuoteStatusChanged:
				return LeadActionLabelEnum.QuoteStatusChanged;
			case LeadEventTypeEnum.QuoteDeleted:
				return LeadActionLabelEnum.QuoteDeleted;
			case LeadEventTypeEnum.QuoteRestored:
				return LeadActionLabelEnum.QuoteRestored;
			case LeadEventTypeEnum.QuoteCreated:
				return LeadActionLabelEnum.QuoteCreated;
			case LeadEventTypeEnum.SurveyCreated:
				return LeadActionLabelEnum.SurveyCreated;
			case LeadEventTypeEnum.SurveyUpdated:
				return LeadActionLabelEnum.SurveyUpdated;
			case LeadEventTypeEnum.SurveyFilesAttached:
				return LeadActionLabelEnum.SurveyFilesAttached;
			case LeadEventTypeEnum.SmsSent:
				return LeadActionLabelEnum.SmsSent;
			case LeadEventTypeEnum.EmailSent:
				return LeadActionLabelEnum.EmailSent;
			case LeadEventTypeEnum.QuoteFinanceProductChanged:
				return LeadActionLabelEnum.QuoteFinanceProductChanged;
			default:
				return this.id
		}
	}

	/**
	 * Lead action object.
	 * @param {string} id Lead action id
	 */
	constructor(public readonly id: string) {}
}

export enum LeadActionLabelEnum {
	Created = "Created",
	Updated = "Updated",
	StatusChanged = "Status",
	NoteCreated = "Note",
	QuoteCommentCreated = "Quote Comment",
	QuoteStatusChanged = "Quote Status",
	QuoteCreated = "Quote Created",
	QuoteDeleted = "Quote Deleted",
	QuoteRestored = "Quote Restored",
	SurveyCreated = "Survey Created",
	SurveyUpdated = "Survey Updated",
	SurveyFilesAttached = "Survey Files Attached",
	SmsSent = "Sms Sent",
	EmailSent = "Email Sent",
	QuoteFinanceProductChanged = "Quote finance product changed"
}